import store from "@/store";
import redirectToLogin from "@/helper/redirectToLogin";

export default (to: any, from: any, next: any) => {
  redirectToLogin(to, from, next);
  return next();
};
